import { IEnv } from "../../../shared/interfaces/IEnv";

export default {
    client: {
        name: "tamarana",
        nomePrefeitura: "Prefeitura Municipal de Tamarana",
        logo: "https://d1cge5fflrvk0g.cloudfront.net/tamarana/logos/logo_tamarana.png",
        brasao: "https://d1cge5fflrvk0g.cloudfront.net/tamarana/logos/logo_tamarana.png",
        municipio: "| TAMARANA - PR",
    },
    webgeo: {
        coordinatesPattern: "EPSG:32722",
        bci: {
            nomeSecretaria: "Secretaria Municipal de Gestão Pública e Finanças",
        },
        confrontante: {
            informacoesRodape: "",
            nomeSecretaria:
                "Secretaria Municipal de Desenvolvimento Urbano e Logística",
        },
        consultaPrevia: {
            nomeSecretaria: "Secretaria Municipal de Urbanismo",
            contact: {
                email: "xxx",
                endereco: "xxx",
                horarioAtendimento: "xxx",
                telefone: "xxx",
            },
            leiUsoDeSolo:
                "PARÂMETROS DE USO DO SOLO - Anexo (X) - Lei no XXXX/XXXX",
            leiVagasDeEstacionamento:
                "VAGAS PARA ESTACIONAMENTO anexo à lei XXXX/XXXXX",
        },
        config: {
            bci: true,
            confrontante: true,
            consultaPrevia: false,
            iptu: false,
            laws: false,
        },
        map: {
            center: [-51.0944317, -23.72825],
            zoom: 19,
        },
    },
    api: {
        url: "https://api-prd.semv.com.br/tamarana/",
    },
    geoserver: {
        url: "https://geoserversp.semv.com.br/geoserver",
        ortoUrl: "https://geoserver-orto.semv.com.br/geoserver",
    },
} as IEnv;
